import React from "react";
import { useNavigate } from "react-router-dom";
import { Breadcrumbs, Link, Typography } from "@mui/material";
import { NavigateNext as NavigateNextIcon } from "@mui/icons-material";
import { tokens } from "@/tokens";

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface FirstSaleBreadcrumbProps {
  items: BreadcrumbItem[];
}

const FirstSaleBreadcrumb: React.FC<FirstSaleBreadcrumbProps> = ({ items }) => {
  const navigate = useNavigate();

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      sx={{ mb: 2 }}
    >
      <Link
        underline="hover"
        color={tokens.text.muted}
        onClick={() => navigate("/first-sale")}
        sx={{ cursor: "pointer", fontSize: 14 }}
      >
        First Sale
      </Link>
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return isLast ? (
          <Typography key={index} color={tokens.text.primary} fontSize={14}>
            {item.label}
          </Typography>
        ) : (
          <Link
            key={index}
            underline="hover"
            color={tokens.text.muted}
            onClick={() => item.href && navigate(item.href)}
            sx={{ cursor: "pointer", fontSize: 14 }}
          >
            {item.label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export { FirstSaleBreadcrumb };
export default FirstSaleBreadcrumb;
